<template>
    <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="70px" class="demo-dynamic" :inline="true">
            <el-form-item label="批量价格" prop="BatchPrice" class="BatchPrice">
                <el-input v-model="ruleForm.BatchPrice" size="small" class="input1"></el-input>
                <el-button type="primary" size="small" @click="batchSetting('price')">批量设置价格</el-button>
            </el-form-item>
            <el-form-item label="批量库存" prop="BatchInventory">
                <el-input v-model="ruleForm.BatchInventory" size="small" class="input1"></el-input>
                <el-button type="primary" size="small" @click="batchSetting('stock')">批量设置库存</el-button>
            </el-form-item>
        </el-form>

        <div v-for="(item, index) of skuList" :key="index" class="gauge" style="min-height: 42px;">
            <div class="left" style="flex-shrink: 0">{{ item.kvName }}</div>

            <div class="valueKv">
                <div class="kvName" v-for="element of item.valueKv">
                    <i class="el-icon-close close" @click="closekvName(element.kvName)"></i>
                    {{ element.kvName }}
                </div>
                <div style="height: 42px">
                    <el-input style="margin-left: 20px;width: 80px;" v-model="attrValueList[index]" size="small"></el-input>
                    <el-button style="margin-left: 10px;height: 32px;" type="primary" size="small" @click="addAttValue(item,index)">添加规格值</el-button>
                </div>
            </div>
        </div>

        <div class="gauge" style="height: 42px;">
            <el-input style="margin-left: 20px;width: 80px;" v-model="attributes" size="small"></el-input>
            <el-button style="margin-left: 10px;height: 32px;" type="primary" size="small" @click="addAtt()">添加规格</el-button>
        </div>

        <el-table size="small" :data="tableData" max-height="450px" border style="width: 100%" v-if="tableData.length != 0">
            <el-table-column v-for="(item, index) of skuList" :key="index" align="center" :prop="'kvName' + index" :label="item.kvName">
                <template slot-scope="{ row }">
                    <el-select
                        v-model="row['kvName' + index]"
                        size="small"
                        placeholder="请选择"
                        style="width: 120px"
                        @change="onSpecChange(row)"
                    >
                        <el-option
                            v-for="opt in item.valueKv"
                            :key="opt.kvId"
                            :label="opt.kvName"
                            :value="opt.kvName"
                        />
                    </el-select>
                </template>
            </el-table-column>

            <el-table-column align="center" label="价格">
                <template slot-scope="scope"
                    ><el-input size="small" style="width: 60%" v-model="scope.row.price" placeholder="请输入价格"></el-input
                ></template>
            </el-table-column>
            <el-table-column align="center" label="供货价">
                <template slot-scope="scope"
                    ><el-input size="small" style="width: 60%" type="number" v-model="scope.row.supplyPrice" placeholder="请输入供货价"></el-input
                ></template>
            </el-table-column>
            <el-table-column align="center" label="利润率">
                <template slot-scope="scope"
                    ><el-input size="small" style="width: 60%" type="number" :disabled="true" :value="(scope.row.supplyPrice && scope.row.price) ? ((scope.row.price - scope.row.supplyPrice) / scope.row.price * 100).toFixed(2) : ''" placeholder="利润率"></el-input
                ></template>
            </el-table-column>
            <el-table-column align="center" label="数字资产">
                <template slot-scope="scope"
                    ><el-input size="small" style="width: 60%" type="number" v-model="scope.row.vbaoEnterRatio" placeholder="请输入数字资产"></el-input
                ></template>
            </el-table-column>
            <el-table-column align="center" label="库存">
                <template slot-scope="scope"
                    ><el-input prop="stock" size="small" style="width: 60%" v-model="scope.row.stock" placeholder="请输入库存"></el-input
                ></template>
            </el-table-column>
            <el-table-column align="center" label="图片">
                <template slot-scope="scope">
                    <el-upload
                        class="avatar-uploader"
                        style="width: 80px; height: 80px; text-align: center"
                        :data="scope.row"
                        action=""
                        :show-file-list="false"
                        :http-request="uploadSkuPicture"
                    >
                        <img v-if="scope.row.pic" :src="scope.row.pic" class="avatar" size="small" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="72" align="center" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" size="small" class="spec-row-del" @click="removeSpecRow(scope.$index)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import eventBus from '../../api/eventBus';
import { get, post, deleteFun, upload } from '@/utils/request.js';

export default {
    data() {
        return {
            ruleForm: {
                BatchPrice: '',
                BatchInventory: '',
                Specifications: ''
            },
            attributes: '',
            Specifications: '',
            rules: {
                stock: [{ required: true, message: '商品库存不能为空', trigger: 'blur' }]
            },
            skuList: [],
            brand: {},
            tableData: [],
            arrData: [],
            attrValueList: [null,null,null]
        };
    },
    watch: {
        // 监听品牌和分类改变数组清空（原先条件监听）
        // brand: {
        //     handler(newVal, oldVal) {
        //         // console.log(newVal, oldVal);
        //         this.skuList = [];
        //     },
        //     immediate: true,
        //     deep: true
        // }
    },
    created() {
        eventBus.$on('Specification', (data) => {
            // 不改变原组件的值
            let array = JSON.parse(JSON.stringify(data))
            // if(this.skuList.length == 3){
            //     this.$message.warning('最多添加3个属性')
            //     eventBus.$emit('speckvName',array.kvName);
            //     return
            // }
            this.skuList.push(array);
            console.log(data); //componentA参数
            this.combination();
        });
        eventBus.$on('speci', (data) => {
            this.brand = data;
            console.log(data);
        });
        // 属性不为空触发
        eventBus.$on('isClear', ()=>{
            this.tableData = [];
            this.skuList = [];
        });
    },
    beforeDestroy() {
        eventBus.$off('Specification');
        eventBus.$off('speci');
        eventBus.$off('isClear');
    },
    methods: {
        addAtt(){
            if(!this.attributes){
               this.$message.warning('请输入规格名称')
                return
            }
            let obj = {
                kvName: this.attributes,
                nameKvId: null,
                valueKv:[]
            }
            this.getOrAdd(obj)
        },

        getOrAdd(obj){
            get("/shop/attrkv/getByName",{kvName: this.attributes}).then((res)=>{
                if(res.success){
                    obj.nameKvId = res.shopAttrKv.kvId
                    this.skuList.push(obj);
                    this.attributes = ''
                }else{
                    this.$message.warning(res.msg)
                }
            })
        },

        getOrAddIndex(obj,index){
            get("/shop/attrkv/getByName",{kvName: this.attrValueList[index]}).then((res)=>{
                if(res.success){
                    obj.kvId = res.shopAttrKv.kvId
                    this.attrValueList[index] = null
                    this.skuList[index].valueKv.push(obj)
                    console.log("=====>this.skuList", this.skuList)
                    this.combination();
                }else{
                    this.$message.warning(res.msg)
                }
            })
        },

        addAttValue(item,index){
            if(!this.attrValueList[index]){
                this.$message.warning('请输入规格值')
                return
            }
            for (let attrValueListElementElement of this.skuList[index].valueKv) {
                if(attrValueListElementElement.kvName == this.attrValueList[index]){
                    this.$message.warning('该规格值已存在')
                    return
                }
            }
            let obj = {
                kvId: '',
                kvName: this.attrValueList[index],
                name: item.kvName
            }
            this.getOrAddIndex(obj,index)
        },


        onSpecChange(row) {
            const ids = [];
            for (let i = 0; i < this.skuList.length; i++) {
                const kvName = row['kvName' + i];
                const found = this.skuList[i].valueKv.find((v) => v.kvName === kvName);
                if (found) ids.push(found.kvId);
            }
            row.skuKvIds = ids.length ? this.ascending(ids.join(',')) : '';
        },

        removeSpecRow(index) {
            if (index < 0 || index >= this.tableData.length) return;
            this.tableData.splice(index, 1);
        },

        closekvName(element) {
            loop: for (let item of this.skuList) {
                for (let i = 0; i < item.valueKv.length; i++) {
                    if (item.valueKv[i].kvName == element) {
                        item.valueKv.splice(i, 1);
                        this.combination();
                        break loop;
                    }
                }
            }
            for (let i = 0; i < this.skuList.length; i++) {
                if (this.skuList[i].valueKv == 0) {
                    eventBus.$emit('speckvName', this.skuList[i].kvName);
                    this.skuList.splice(i, 1);
                    if (this.skuList.length != 0) {
                        this.combination();
                    }
                    break;
                }
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    alert('submit!');
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        combination() {
            let combine = function (skuList) {
                // console.log(skuList);
                let res = [];
                let recursion = function (chunkIndex, prev) {
                    if (chunkIndex >= skuList.length) {
                        return;
                    }
                    let skuValueList = skuList[chunkIndex] ? skuList[chunkIndex].valueKv : [];

                    if (!skuValueList || skuValueList.length === 0) {
                        // 跳过空的 SKU 属性
                        recursion(chunkIndex + 1, prev);
                        return;
                    }
                    // console.log(chunk);y
                    let isLast = chunkIndex === skuList.length - 1;
                    for (let val of skuValueList) {
                        let temporary = prev.concat(val);
                        if (isLast) {
                            // 如果已经处理到数组的最后一项了 则把拼接的结果放入返回值中
                            res.push(temporary);
                        } else {
                            recursion(chunkIndex + 1, temporary);
                        }
                    }
                };
                // 从属性数组下标为 0 开始处理  // 并且此时的 prev 是个空数组
                recursion(0, []);
                return res;
            };
            let arr = combine(this.skuList);
            console.log(arr);
            this.tableData = [];
            let j = 0;
            for (let item of arr) {
                let i = 0;
                let obj = {
                    skuKvIds: ''
                };

                for (let element of item) {
                    let key1 = 'kvName' + i;
                    let key2 = 'price';
                    let key3 = 'stock';
                    let key4 = 'pic';
                    let key5 = 'id';
                    i++;
                    obj[key1] = element.kvName;
                    obj[key2] = '';
                    obj[key3] = '';
                    obj[key4] = '';
                    obj[key5] = j++;
                    obj.skuKvIds += element.kvId + ',';
                }
                if (obj.skuKvIds.length > 0) {
                    obj.skuKvIds = obj.skuKvIds.substr(0, obj.skuKvIds.length - 1);
                }
                obj.skuKvIds = this.ascending(obj.skuKvIds);

                obj.supplyPrice = '';
                obj.vbaoEnterRatio = '';

                console.log(obj);
                this.tableData.push(obj);
                // break;
            }
            console.log(this.tableData);
        },
        // 升序排列
        ascending(value) {
            var array = new Array();
            array = value.split(',');
            // for (var element in array) {
            //     array[element] = parseInt(array[element]);
            // }
            array = array.sort(function (a, b) {
                return a - b;
            });
            return array.toString();
        },

        // 上传图片
        uploadSkuPicture(params) {
            console.log(params);
            const file = params.file;
            let product = params.data;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            upload(`/mpp/image/upload`, formData).then((res) => {
                if (res.success && res.code == 200) {
                    for (let item of this.tableData) {
                        if (item.id == product.id) {
                            item.pic = res.url;
                        }
                    }

                    console.log(this.tableData);
                }
            });
        },
        // 批量设置
        batchSetting(value) {
            if (this.tableData.length != 0) {
                for (let item of this.tableData) {
                    if (value == 'price') {
                        if (this.ruleForm.BatchPrice == '') {
                            this.$message({
                                message: '价格不能为空',
                                type: 'error',
                                duration: 2000
                            });
                            return;
                        }
                        item.price = this.ruleForm.BatchPrice;
                    }
                    if (value == 'stock') {
                        if (this.ruleForm.BatchInventory == '') {
                            this.$message({
                                message: '库存不能为空',
                                type: 'error',
                                duration: 2000
                            });
                            return;
                        }
                        item.stock = this.ruleForm.BatchInventory;
                    }
                }
                if (value == 'price') {
                    this.ruleForm.BatchPrice = '';
                }
                if (value == 'stock') {
                    this.ruleForm.BatchInventory = '';
                }
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.input1 {
    margin-right: 15px;
}
.Specifications {
    padding-left: 100px;
    margin-bottom: 22px;
}
.input2 {
    width: 50%;
    margin: 10px 0;
}
::v-deep .el-input {
    width: 100px;
}
::v-deep .el-select {
    width: 100px;
}
::v-deep .el-form-item {
    margin-bottom: 10px;
}

.gauge {
    color: #606266;
    font-weight: normal;
    font-size: 14px;
    display: flex;
    .left {
        line-height: 32px;
        width: 58px;
        margin-right: 12px;
        text-align: right;
    }
}
.valueKv {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;

    .kvName {
        padding: 0 10px;
        height: 32px;
        line-height: 30px;
        text-align: center;
        border: 1px solid #ccc;
        margin: 0 10px 10px 0;
        position: relative;
    }
    .close {
        position: absolute;
        top: -10px;
        right: -10px;
        width: 20px;
        height: 20px;
        line-height: 20px;
        background-color: #409eff;
        color: #fff;
        border-radius: 100%;
    }
}
.el-table {
    margin-bottom: 20px;
}

::v-deep .el-upload {
    width: 80px !important;
    height: 80px !important;
    text-align: center;
}
.avatar-uploader {
    margin-left: 50%;
    transform: translate(-50%, 0);
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
}
.avatar {
    width: 80px;
    height: 80px;
    display: block;
}
.spec-row-del {
    color: #f56c6c;
}
</style>
